<template>
  <div>

    <v-form ref="inputForm" @submit.prevent="">
      <v-container pa-0 fill-height ms-auto class="validateMobile pop-container px-10 fill-height ms-auto">    

        <!-- Collect Mobile Number Section -->
        <v-sheet v-if="step == 1" color="white" class="custom-shadow pa-10" style="width:100%">
          
          <h1 class="text-center VerificationMobileText " v-html="$let('CollectMobileNumberSectionTitle')"></h1>
          <h3 class="text-center text--text" v-html="$let('CollectMobileNumberSectionTitle2')"></h3>

          <v-banner two-line tile elevation="0" color="InfoBanner">
            <v-avatar slot="icon" size="40">
              <v-icon icon="icon" color="InfoBanner-darken-1">mdi-information-variant</v-icon>
            </v-avatar>
            <v-sheet color="InfoBanner InfoBanner-darken-1--text" v-html="$let('CollectMobileNumberSectionSubTitle')"></v-sheet>
          </v-banner>

        <v-row>
          <v-col cols="12" md="12">
            <div class="ma-auto mt-5">
              <MobileNumber 
                v-model="model.mobileNumber"
                :label="$let('MobileNumberEntry')"
                :rules="[validationRules.required, validationRules.ukMobile]">
              </MobileNumber>
            </div>
            <v-sheet class="text-center" color="error--text" v-html="errorRequestingOTP"></v-sheet>
          </v-col>
        </v-row>

          <div class="text-center mt-10">
            <StepperButtons 
              @continueClick="_requestOTPClick"
              @backClick="_backButtonClick" >
            </StepperButtons>
          </div>

        </v-sheet>

        <!-- Collect OTP Section -->
        <v-sheet v-if="step == 2" color="white" class="custom-shadow pa-10" style="width:100%">
          
          <h1 class="text-center VerificationMobileText" v-html="$let('CollectMobileNumberOTPSectionTitle')"></h1>
          <h3 class="text-center text--text" v-html="$let('CollectMobileNumberOTPSectionTitle2')"></h3>

          <v-banner two-line rounded elevation="0" color="InfoBanner">
            <v-avatar slot="icon" size="40">
              <v-icon icon="icon" color="InfoBanner-darken-1">mdi-information-variant</v-icon>
            </v-avatar>
            <v-sheet color="InfoBanner InfoBanner-darken-1--text" v-html="$let('CollectMobileNumberOTPSectionSubTitle')"></v-sheet>
          </v-banner>

        <v-row class="validateMobile--OTP">
          <v-col cols="12" md="12">
            <div class="ma-auto mt-5">
              <TextField 
                type="number"
                maxlength="6"
                max="999999"
                v-model="model.mobileNumberOTP"
                :label="$let('MobileNumberOTPEntry')"
                :rules="[validationRules.numeric, validationRules.required]">
              </TextField>
            </div>
            <v-sheet class="text-center" color="error--text" v-html="errorValidatingOTP"></v-sheet>
          </v-col>
        </v-row>

          
        <div class="text-center mt-10">
          <StepperButtons
            @continueClick="_validateOTPClick"
            @backClick="_backButtonClick" >
          </StepperButtons>
        </div>

        </v-sheet>

      </v-container>
    </v-form>
    
    <LoadingOverlay
      :show="inAction">
    </LoadingOverlay>

  </div>
</template>

<script>

  import { mapActions } from "vuex";
  import StepperButtons from '../components/stepper-buttons.vue'
  import TextField from '@/shared/components/text-field.vue'
  import MobileNumber from '@/shared/components/mobile-number.vue'
  import LoadingOverlay from '@/shared/components/loading-overlay.vue'
  import generic from '@/shared/utils/generic.js';
  import paramKeys from '../constants/param-keys.js'
  import constants from '../constants/generic.js'
  import validators from '@/shared/utils/validators.js';
  import router from '../router';
  import routerNames from '../router/router-names';

  export default {
    name: 'ValidateMobile',
    components: {
      MobileNumber,
      TextField,
      LoadingOverlay,
      StepperButtons
    },
    data() {
      return {
        step: 1,
        validationRules: validators.validationRules({ 
                            reqFld: this.$let('RequiredFieldEmptyMessage'), 
                            invValue: this.$let('InvalidValue'),
                            invPhoneNumber: this.$let('InvalidPhoneNumber') 
        }),
        errorRequestingOTP: "",
        errorValidatingOTP: "",
        inAction: false,
        model: {
          mobileNumber: undefined, // "+44 7911 123456",
          mobileNumberOTP: undefined, //"1",
          enquiryFormAvailable: false,
        },
      }
    },
    async mounted() {
      if (!this.$store.state.loanEnquiryData.eligible) router.push({ name: routerNames.Home})

      const isMember = this.$store.state.loanEnquiryData.isMember;
      const paymentStepEnabled = generic.paramValue(this.$store, paramKeys.PaymentStepEnabled).toBool();
      const paymentConfirmed = this.$store.state.paymentConfirmed;
      if (!isMember && paymentStepEnabled && !paymentConfirmed) {
        router.push({ name: routerNames.Payment });
      }

      this.model.mobileNumber = this.$store.state.loanEnquiryData.mobileNumber; // Maintain mobileNumber if coming back from enquiry-form
      this.model.enquiryFormAvailable = this.$store.state.loanEnquiryData.enquiryFormAvailable;
    },    
    methods: {
      ...mapActions(["otpRequest", "otpValidate", "updateLocalLoanEnquiryData"]),
      
      async _requestOTPClick() {
        if (this.$refs.inputForm.validate()) {
          this.errorRequestingOT = "";
          this.inAction = true;
          const resp = await this.otpRequest(this.model);
          if (resp.Response.StatusCode === constants.LOAN_ENQUIRY_SUCCESS){
            this.model.mobileNumberOTP = "";
            this.errorValidatingOTP = "";
            this.step++;
          }
          else this.errorRequestingOTP = this.$let("RequestOTPError_".concat(resp.Response.StatusCode));
          this.inAction = false;
        }
      },

      async _validateOTPClick() {
        if (this.$refs.inputForm.validate()) {
          this.errorValidatingOTP = "";
          this.inAction = true;
          const resp = await this.otpValidate(this.model);
          if (resp.Response.StatusCode === constants.LOAN_ENQUIRY_SUCCESS) {
            this.model.enquiryFormAvailable = true;
            this.updateLocalLoanEnquiryData(this.model);
            router.push({ name: routerNames.EnquiryForm });
          }
          else {
            this.errorValidatingOTP = this.$let("ValidateOTPError_".concat(resp.Response.StatusCode));
            this.inAction = false; // Only on error will stop the "loading" animation
          }
        }
      },

      _backButtonClick() { 
        if (this.inAction) return;
        if (this.step === 1) {
          router.push({ name: routerNames.ConfirmMembership });          
        }
        else this.step--;
      },            
    }    
  };
</script>

<style lang="scss" scoped>

</style>